import { easepick, AmpPlugin } from "@easepick/bundle"

class BirthdateInput extends HTMLInputElement {
  connectedCallback() {
    this.type = 'text'
    this.autocomplete = 'off'
    this.placeholder = 'DD-MM-YYYY'

    // Convert initial YYYY-MM-DD value to DD-MM-YYYY for display
    if (this.value && this.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [year, month, day] = this.value.split('-')
      this.value = `${day}-${month}-${year}`
    }

    // Auto-insert dashes while typing
    this.addEventListener('input', this.formatWithDashes.bind(this))

    this.picker = new easepick.create({
      element: this,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/themes/flat.min.css'
      ],
      format: 'DD-MM-YYYY',
      autoApply: true,
      readonly: false,
      plugins: [AmpPlugin],
      AmpPlugin: {
        resetButton: true,
        dropdown: {
          months: true,
          years: true,
          minYear: 1950,
          maxYear: new Date().getFullYear()
        }
      }
    })

    // Convert to YYYY-MM-DD before form submission
    this.form?.addEventListener('submit', this.convertToIso.bind(this))
  }

  convertToIso() {
    if (this.value && this.value.match(/^\d{2}-\d{2}-\d{4}$/)) {
      const [day, month, year] = this.value.split('-')
      this.value = `${year}-${month}-${day}`
    }
  }

  formatWithDashes(event) {
    const cursorPosition = this.selectionStart
    const oldValue = this.value
    const digits = oldValue.replace(/\D/g, '').slice(0, 8)

    let formatted = ''
    for (let i = 0; i < digits.length; i++) {
      if (i === 2 || i === 4) formatted += '-'
      formatted += digits[i]
    }

    // Add trailing dash after DD or DD-MM
    if (digits.length === 2 || digits.length === 4) {
      formatted += '-'
    }

    if (formatted !== oldValue) {
      this.value = formatted

      // Move cursor to end when dash is auto-appended
      const newCursor = formatted.length
      this.setSelectionRange(newCursor, newCursor)
    }
  }

  disconnectedCallback() {
    if (this.picker) {
      this.picker.destroy()
    }
  }
}

customElements.define('birthdate-input', BirthdateInput, { extends: 'input' })
